const colors = {
    appBarBackground: '#ffffff',
    lightShadow: '#F0F0F0',
    blue: '#032c58',
    black: '#000000',
    button: '#fbc10f',
    darkGray: '#222222',
    focusedField: '#032c58',
    main: '#fbc10f',
    lightMain: '#C89EEC',
    lighterMain: '#fef3cf',
    lightBorderGray: '#E1E1E1',
    lightGray: '#FAFAFA',
    lightDarkerGray: '#BFBFBF',
    darkIcon: '#263238',
    labelColor: '#929292',
    lightWarning: 'rgba(255, 0, 0, 0.20)',
    midGray: '#C4C4C4',
    midDarkerGray: '#737373',
    warning: '#FF0000',
    white: '#FFFFFF',
    footer: '#f2f2f2',
    blueDisabled: 'rgba(3, 44, 88, 0.5)',
}

export default colors
